import { ca } from '@cian/analytics';

export function trackStarsRatingShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Show',
    label: 'FeedbackRating',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
}

export function trackCommentRatingShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Show',
    label: 'FeedbackComment',
    page: {
      extra: {
        chat_id: 'chatbot',
      },
    },
  });
}

export function trackRatingSend(rating: number, comment?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Send',
    label: 'Feedback',
    page: {
      extra: {
        chat_id: 'chatbot',
        rating,
        comment,
      },
    },
  });
}
